<div class="search-results-tab-container own-scroll">
  <nb-list
    *ngIf="firstCard.news.length > 0"
    nbInfiniteList
    [threshold]="440"
    (bottomThreshold)="loadNext(firstCard)"
    (scroll)="onScroll($event)"
    class="search-result-list"
  >
    <nb-list-item
      *ngFor="let result of firstCard.news; let i = index"
      (click)="navigateToSubscribers(result, data.type)"
    >
      <nb-icon nbPrefix icon="briefcase-outline" pack="eva"></nb-icon>
      <span class="label" *ngIf="result.firstNames">{{ 'PERSON.FIRSTNAME' | translate }}:</span>
      {{ result.firstNames }}
      <span class="label" *ngIf="result.middleName">{{ 'PERSON.MIDDLENAME' | translate }}:</span>
      {{ result.middleName }}
      <span class="label">{{ 'PERSON.LASTNAME' | translate }}:</span>
      {{ result.lastName }}
      <span class="label" *ngIf="result.company"
        >{{ 'IDENTIFICATION.COMPANY_NAME' | translate }}:</span
      >
      {{ result.company?.name }}
    </nb-list-item>
    <nb-list-item *ngFor="let _ of firstCard.placeholders">
      <p>Loading ...</p>
    </nb-list-item>
  </nb-list>
  <div *ngIf="data.results.length === 0" class="no-search-results">
    {{ 'GLOBAL_SEARCH.NO_SEARCH_RESULTS' | translate }}
  </div>
</div>
<div class="z" [class]="data.count > 5 ? 'showMoreIcon' : 'hideMoreIcon'">
  <nb-icon nbSuffix icon="{{ scrollIcon }}" pack="eva" class="icon-navigate"></nb-icon>
</div>
